import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { nanoid } from 'nanoid'
import produce from 'immer'

import { AppStatus } from '~shared/models/AppStatus'
import { Toast } from '~shared/models/Toast'

import {
  addToastToBeDisplayed,
  toastDisplayed,
  initApp,
} from './actions'

export interface AppData {
  appStatus: AppStatus
  toastsToBeDisplayed: { [toastkey: string]: Toast }
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface -- allow empty example interface
export interface BootstrapData {
  // add bootstrap data here
}

export interface GlobalState {
  readonly appData: AppData
  bootstrapData?: BootstrapData
}

const INITIAL_STATE: GlobalState = {
  appData: {
    appStatus: AppStatus.uninitialized,
    toastsToBeDisplayed: {},
  },
}

export const globalReducer = reducerWithInitialState(INITIAL_STATE)
  /**
   * init App
   */
  .case(initApp.started, (state) => {
    return produce(state, (draft: GlobalState) => {
      draft.appData.appStatus = AppStatus.initializing
    })
  })
  .case(initApp.done, (state, { result }) => {
    return produce(state, (draft: GlobalState) => {
      draft.appData.appStatus = AppStatus.initialized
      draft.bootstrapData = result
    })
  })
  .case(initApp.failed, (state) => {
    return produce(state, (draft: GlobalState) => {
      draft.appData.appStatus = AppStatus.failedInitialization
    })
  })

  /**
   * Toast Management
   */
  .case(addToastToBeDisplayed, (state, payload) => {
    return produce(state, (draft) => {
      draft.appData.toastsToBeDisplayed[nanoid(8)] = payload
    })
  })
  .case(toastDisplayed, (state, payload) => {
    return produce(state, (draft) => {
      delete draft.appData.toastsToBeDisplayed[payload.toastKey]
    })
  })
